module.exports = __webpack_public_path__ + "img/deal-car-1.6a2d0d7f.png";